import { selectCurrentWaChat } from './redux/TeamInboxSelectors';
import RowStack from '@common/components/common/row-stack/RowStack';
import { useAppSelector } from '@common/reducers/hooks/store.hook';
import ContactAvatar from '@extension/context/content/components/bulk-dashboard/contact-table/contact-avatar';
import {
  Box,
  Typography,
} from '@mui/material';
import { Stack } from '@mui/system';
import { memo, useMemo } from 'react';
import classes from './team-inbox.module.scss';
import ChatParticipantsList from './chat-participants-list';
import ChatHeaderActionButtons from './chat-header-action-buttons';


const ChatHeader = memo(() => {

  const waChat = useAppSelector(selectCurrentWaChat);

  // Get the chat ID - handle both data structures (from WhatsApp and from database)
  const chatId = waChat?._serialized || waChat?.id?._serialized || waChat?._id;

  // Memoize the avatar props to prevent unnecessary re-renders
  const avatarProps = useMemo(() => ({
    size: 40,
    textSize: 16,
    contactId: chatId,
    sx: { marginInlineEnd: 2 },
  }), [chatId]);


  return (
    <Box className={classes.chatHeaderContainer}>
      <RowStack className={classes.chatHeaderRow}>
        <RowStack className={classes.chatHeaderLeft}>
          {waChat && (
            <>
              <Box className={classes.chatHeaderAvatarContainer}>
                <ContactAvatar {...avatarProps} />
              </Box>
              <Stack className={classes.chatHeaderStack}>
                <Typography className={classes.chatHeaderTitle}>
                  {waChat?.name}
                </Typography>
                <ChatParticipantsList />
              </Stack>
            </>
          )}
        </RowStack>
        <RowStack className={classes.chatHeaderRight}>
          <ChatHeaderActionButtons waChatId={chatId} />
        </RowStack>
      </RowStack>
    </Box>
  );
});

export default ChatHeader;
